// extracted by mini-css-extract-plugin
export default {"LoadingSQLViewer":"SQLViewer_LoadingSQLViewer__KeZGo","SQLViewer":"SQLViewer_SQLViewer__s2olr"};